module.exports = __webpack_public_path__ + "static/Guidebutton_developer-c89a0dfba5bddb252c62433d6b9c7abf.svg";